import * as stylex from "@stylexjs/stylex";
import Link from "next/link";
import { colors, layoutAreas } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
const styles = {
    link: {
        kMwMTN: "x1vc0dw",
        kWkggS: "x6e1os3",
        kmVPX3: "x1pr41jk",
        kaIpWk: "x12oqio5",
        kGzVvX: "x57yxf0",
        $$css: true
    }
};
export const LandingButton = ({ children })=>{
    return <div className="x1uq3dmu x2b8uid x1bd1j73 x16bybu0">
      <Link href="/articles/access" {...stylex.props(typography.heading3, styles.link)}>
        {children}
      </Link>
    </div>;
};
